'use strict';

/**
 * initialize slick
 * @function initSlick
 */
function initSlick() {
    const isMobile = $(window).width() < 1024;
    const $slickContainer = $('.slick-carousel-container');

    // Initialize Slick for mobile
    if (isMobile && !$slickContainer.hasClass('slick-initialized')) {
        $slickContainer.slick({
            dots: true,
            arrows: false,
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1
        });
    }

    // Destroy Slick for desktop
    if (!isMobile && $slickContainer.hasClass('slick-initialized')) {
        $slickContainer.slick('unslick');
    }
}
$(document).ready(function () {
    // Initialize Slick on page load
    initSlick();

    // Recheck on window resize
    $(window).resize(function () {
        initSlick();
    });
});
